import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import { Fade, Switch, Typography } from "@mui/material"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Campaigns() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState({
        campaigncode: '',
        calculatecontacts: '0'
    })

    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        dispatch(setCurrentPage(`Campaigns`))
    }, [dispatch]);

    //Get users data
    async function fetchData(params: object = {}) {
        setLoading(true)
        //Заменить энд поинт на компании - как будет готов!!!!
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/campaign`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                    // setFilterParams({ ...filterParams, calculatecontacts: '0' })
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={tableData} page={'campaign'} />, [tableData]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "space-between", flexWrap: 'wrap', gap: 2 }}>
                <Link to='/campaign' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: 1 }} variant="outlined"><TranslatedText text={"Add Campaign"} /></Button>
                </Link>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 20 }}>
                    <TextField sx={{ minWidth: 220 }} value={filterParams.campaigncode} onChange={(e) => setFilterParams({ ...filterParams, campaigncode: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Campaign code'} />} />
                    <Box sx={{ display: "flex", alignItems: "center", border: 1, borderRadius: 1, borderColor: '#c4c4c4', color: '#686c77', paddingLeft: 1 }}>
                        <Typography><TranslatedText text={'Calculate the number of remaining contacts'} /></Typography>
                        <Switch onChange={(e) => setFilterParams({ ...filterParams, calculatecontacts: filterParams.calculatecontacts === '0' ? '1' : '0' })} checked={Boolean(+filterParams.calculatecontacts)} />
                    </Box>
                    <Button onClick={() => fetchData(filterParams)} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={"Apply"} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}